import svgFiles from '@/assets/svg/svgFiles';
import ConfirmationModal from '@/components/molecules/ConfirmationModal';
import useSendScreenerReminder from '@/hooks/notifications/useSendScreenerReminder';
import { Image, Text, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';

const UnscreenedRiskHoverIcon = () => {
  const [isHovered, setIsHovered] = useState(false);
  let cancelTimeoutRef: NodeJS.Timeout | string | number | undefined = undefined;

  const {
    mutate: sendScreenerReminder,
    error: sendScreenerReminderError,
    isPending,
  } = useSendScreenerReminder(() => {
    setIsConfirmationModalOpen(false);
    setIsHovered(false);
  });

  const triggerHover = () => {
    setIsHovered(true);
    clearTimeout(cancelTimeoutRef);
  };

  const startUnHoverTimeout = () => (cancelTimeoutRef = setTimeout(() => setIsHovered(false), 300));

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  return (
    <VStack position={'relative'}>
      <VStack
        position={'absolute'}
        display={isHovered ? 'flex' : 'none'}
        backgroundColor={'extra.white'}
        borderRadius={'8px'}
        boxShadow="0px 8px 34px 0px #0041791A"
        width={'260px'}
        height={'132px'}
        padding={'20px'}
        top={'30px'}
        left={'30px'}
        gap={'10px'}
        alignItems={'start'}
        onMouseEnter={triggerHover}
      >
        <Text variant={'urbanistMediumRegular'} onMouseEnter={triggerHover} onMouseOut={startUnHoverTimeout}>
          Research suggests that quick screeners taken monthly help people to visualize and track their wellness as they
          seek to improve.
        </Text>
        <Text
          variant={'urbanistMaximumBold12'}
          color={'primary.500'}
          onMouseEnter={triggerHover}
          cursor={'pointer'}
          onClick={() => setIsConfirmationModalOpen(true)}
        >
          SEND SCREENER
        </Text>
      </VStack>
      <Image
        minWidth={'28px'}
        height={'28px'}
        boxShadow={isHovered ? '0px 8px 20px 0px #00417966' : '0px 4px 12px 0px #0041794D'}
        padding={'6px'}
        borderRadius={'6px'}
        backgroundColor={'primary.500'}
        src={svgFiles.arrowRightCurvedWhite}
        onMouseEnter={triggerHover}
        onMouseOut={startUnHoverTimeout}
      />

      <ConfirmationModal
        title="Send Screener Reminder"
        description="This will send a reminder to every organization member to retake the screener."
        errorText={sendScreenerReminderError?.errors[0].message}
        confirmButtonText="Send"
        isOpen={isConfirmationModalOpen}
        onClose={() => {
          setIsConfirmationModalOpen(false);
          setIsHovered(false);
        }}
        confirmLoading={isPending}
        onConfirm={sendScreenerReminder}
      />
    </VStack>
  );
};

export default UnscreenedRiskHoverIcon;
